<div class="panel" id="installation">
  <div class="panel-content selectable" (click)="panelClick.emit()">
    <div class="casto-card">
      <div class="header">
        <span class="casto-title" [innerHTML]="title"></span>

        <ng-casto-button
          class="primary"
          [label]="'generic.details' | translate"
          (click)="detailsClick.emit()"></ng-casto-button>
      </div>
    </div>
  </div>
</div>
